import RebookSlotSelector from '../Payment/RebookSlotSelector';

export default function DateSelect({ selectedDate, setSelectedDate }) {
  return (
    <div className="date-select-panel flex-column mb-12 p-24 border-light-purple radius-24">
      <h4 className="mb-12">Date</h4>
      <RebookSlotSelector
        selectedTimeSlot={selectedDate}
        setSelectedTimeSlot={setSelectedDate}
      />
    </div>
  );
}
